import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import {
  getMutationFn,
  HttpHeaders,
} from '../../common/queryClient/getMutationFn';
import { DataObjectSchema, DataObjectValidFormDataType } from '../schema';
import { DataObjectDescriptionVersionUrl } from './DataObjectDescriptionVersionUrl';
import { DataObjectFormDataType } from '../types';

const postDataObject = (
  dataobject: DataObjectValidFormDataType,
  headers?: HttpHeaders,
) =>
  apiClient
    .post<DataObjectFormDataType>(
      expand(DataObjectDescriptionVersionUrl.edit, {}),
      DataObjectSchema.parseMutationDto(dataobject),
      headers ? { headers } : undefined,
    )
    .then((response) => response.data);

const patchDataObject = (
  id: number,
  dataobject: Partial<DataObjectValidFormDataType>,
  headers?: HttpHeaders,
) =>
  apiClient
    .patch<DataObjectFormDataType>(
      expand(DataObjectDescriptionVersionUrl.edit, { id }),
      DataObjectSchema.parseMutationDto(dataobject),
      headers ? { headers } : undefined,
    )
    .then((response) => response.data);

const deleteDataObject = (id: number) =>
  apiClient
    .delete<void>(expand(DataObjectDescriptionVersionUrl.edit, { id }))
    .then((response) => response.data);

export const useMutateDataObjectQuery = createApiMutationHook(
  ['dataObject'],
  getMutationFn(postDataObject, patchDataObject, deleteDataObject),
);
